import React from "react";
import { useRef, useState } from "react";
import emailjs from "emailjs-com";
import "./contact.css";
import Images from "../../data/Images";
import Seperator from "../../Common/Seperator/Seperator";

const Contact = () => {
  const formRef = useRef(1);
  const [done, setDone] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    emailjs
      .sendForm(
        "service_h3wnmb6",
        "template_qfvi48e",
        formRef.current,
        "-gqDdbu2jJ67mVJgN"
      )
      .then(
        (result) => {
          console.log(result.text);
          setDone(true);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div className="contact">
      <div className="c-rec">
        <div className="c-cont">
          <div className="titles">
            <div data-aos="fade-up" className="c-title">
              <Seperator /> <h2>Get In Touch</h2>
              <Seperator />
            </div>
            <div data-aos="fade-up" className="c-title-c">
              Let's Turn Your <br /> Dreams Into <br /> Reality.
            </div>
          </div>
          <div data-aos="fade-up" className="img">
            <img src={Images.Touch} alt="touch" />
          </div>
        </div>
        <div className="c-cont1">
          <div className="c-form">
            <form ref={formRef} onSubmit={handleSubmit}>
              <div data-aos="fade-up" className="form"><input type="text" name="user_name" /> <label>Name</label> </div> 
              <div data-aos="fade-up" className="form"><input type="text" name="user_subject" /> <label>Subject</label> </div>
              <div data-aos="fade-up" className="form"><input type="text" name="user_email" /> <label>Email</label> </div>
              <div data-aos="fade-up" className="form"><textarea rows="5" name="message" /> <label>Message</label> </div>
              <button data-aos="fade-up">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                Submit
                </button>
              {done && <div className="note">Email Sent</div>}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
